<template>
  <div>
    <el-steps
      :active="activeStep"
      finish-status="success"
      align-center
      style="margintop: 50px"
    >
      <el-step title="Datos Generales"></el-step>
      <el-step title="Datos Impositivos"></el-step>
      <el-step title="Datos Bancarios"></el-step>
      <el-step v-if="!isConfirmProvider" title="Usuario"></el-step>
    </el-steps>
  </div>
</template>
<script>
export default {
  props: {
    activeStep: {
      type: Number,
      default: 0
    },
    isConfirmProvider: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// MySteps.vue?2e6f411b